/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "banklin": {
        "nested": {
          "rewards": {
            "nested": {
              "Reward": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "rewardProgramToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "flatReward": {
                    "type": ".squareup.banklin.rewards.Reward.FlatRewardTerms",
                    "id": 1
                  },
                  "percentageReward": {
                    "type": ".squareup.banklin.rewards.Reward.PercentageRewardTerms",
                    "id": 4
                  }
                },
                "nested": {
                  "FlatRewardTerms": {
                    "fields": {
                      "rewardAmount": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "minimumSpendAmount": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "PercentageRewardTerms": {
                    "fields": {
                      "rewardBasisPoints": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "terms": {
                    "oneof": [
                      "flatReward",
                      "percentageReward"
                    ]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward && !$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward?.nested?.FlatRewardTerms && !$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward?.nested?.PercentageRewardTerms) {
	$root.addJSON(jsonData);
}

/**
 * A discount applied to a transaction.
 *
 * SOURCE Reward @ squareup/banklin/rewards.proto at 9:1
 */
export const Reward = $root.lookupType('squareup.banklin.rewards.Reward');
fixType(Reward);
Builder.createAndAttachToType(Reward);
/**
 * SOURCE FlatRewardTerms @ squareup/banklin/rewards.proto at 13:3
 */
Reward.FlatRewardTerms = $root.lookupType('squareup.banklin.rewards.Reward.FlatRewardTerms');
fixType(Reward.FlatRewardTerms);
Builder.createAndAttachToType(Reward.FlatRewardTerms);
/**
 * SOURCE PercentageRewardTerms @ squareup/banklin/rewards.proto at 18:3
 */
Reward.PercentageRewardTerms = $root.lookupType('squareup.banklin.rewards.Reward.PercentageRewardTerms');
fixType(Reward.PercentageRewardTerms);
Builder.createAndAttachToType(Reward.PercentageRewardTerms);
